import * as React from 'react';
import * as moment from 'moment';
import { Button, ControlLabel, FormControl, FormGroup, Modal } from 'react-bootstrap';
import MaskedInput from 'react-maskedinput';

interface IProps {
    show: boolean,
    recipientAlias: string,
    donorAlias: string,
    onSubmit: (surgeryDate: string) => void,
    onClose: () => void
}

const KflDirectDetails = (props: IProps) => {
    const [surgeryDate, setSurgeryDate] = React.useState('');

    const handleSubmit = () => {
        props.onSubmit(surgeryDate);
    };

    const { show, recipientAlias, donorAlias } = props;

    const disableSubmit = moment(surgeryDate, 'MM/DD/YYYY', true).isValid() == false;

    return (
        <Modal show={show} backdrop='static' onHide={props.onClose}>
            <Modal.Header closeButton>
                <Modal.Title>
                    Start Internal Direct
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{ marginBottom: 20 }}>Select surgery date for {donorAlias} to donate to {recipientAlias}</div>
                <FormGroup>
                    <ControlLabel>Surgery Date:</ControlLabel>
                    <MaskedInput
                        className='form-control'
                        mask='11/11/1111'
                        placeholder='mm/dd/yyyy'
                        value={surgeryDate}
                        onChange={(e: React.FormEvent<FormControl & HTMLInputElement>) => setSurgeryDate(e.currentTarget.value)}
                    />
                </FormGroup>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' disabled={disableSubmit} onClick={handleSubmit}>Confirm</Button>
                <Button onClick={props.onClose}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default KflDirectDetails